module.exports = __webpack_public_path__ + "img/LightStep.2b9728da.png";